import { FunctionComponent, InputHTMLAttributes } from 'react';
import { cn } from '../../../utilities/cn';
import SearchIcon from '@mui/icons-material/Search';
import { debounce } from 'lodash';

interface SearchBarProps extends InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  searchHandler: (input: string) => void;
  debounceTime?: number;
  label?: string;
}

const SearchBar: FunctionComponent<SearchBarProps> = ({
  debounceTime,
  searchHandler,
  className,
  placeholder,
  ...props
}) => {
  const debounceSearch = debounce((value: string) => {
    searchHandler(value);
  }, debounceTime);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (debounceTime) {
      debounceSearch(event.target.value);
    } else {
      searchHandler(event.target.value);
    }
  };

  return (
    <>
      {props.label && (
        <label className="my-4 font-semibold text-mainblue" htmlFor={props.id}>
          {props.label}
        </label>
      )}

      <div className="group relative">
        <input
          onChange={handleChange}
          className={cn(
            'w-full appearance-none rounded-md border border-gray-300 px-3 py-2 pl-7 text-sm leading-tight text-gray-800 transition-colors hover:border-blue-600 focus:border-blue-600 focus:outline-none focus:ring-blue-600',
            className,
          )}
          type="text"
          placeholder={placeholder || 'Search...'}
          id="search-input"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          aria-autocomplete="both"
          {...props}

        />

        <div className="pointer-events-none absolute inset-y-0 left-2 flex items-center">
          <SearchIcon className="text-lg text-gray-400 transition-colors group-focus-within:text-blue-600 group-hover:text-blue-600" />
        </div>
      </div>
    </>
  );
};

export default SearchBar;
